import React, { useCallback, useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";

const ProductGallery = ({ images, alt }) => {
  const [emblaRef, embla] = useEmblaCarousel({ loop: images.length > 1, align: "start" });
  const [selected, setSelected] = useState(0);

  const onSelect = useCallback(() => {
    if (embla) setSelected(embla.selectedScrollSnap());
  }, [embla]);

  useEffect(() => {
    if (!embla) return;
    embla.on("select", onSelect);
    onSelect();
  }, [embla, onSelect]);

  const scrollTo = (i) => embla && embla.scrollTo(i);

  if (images.length === 1) {
    return (
      <div className="aspect-[3/4] bg-ink-800 overflow-hidden">
        <img src={images[0]} alt={alt} className="w-full h-full object-cover" />
      </div>
    );
  }

  return (
    <div data-testid="product-gallery">
      <div className="relative group">
        <div className="overflow-hidden aspect-[3/4] bg-ink-800" ref={emblaRef}>
          <div className="flex h-full">
            {images.map((src, i) => (
              <div className="flex-[0_0_100%] min-w-0 h-full" key={i}>
                <img src={src} alt={`${alt} ${i + 1}`} className="w-full h-full object-cover" />
              </div>
            ))}
          </div>
        </div>
        <button
          onClick={() => embla && embla.scrollPrev()}
          data-testid="gallery-prev"
          className="absolute left-4 top-1/2 -translate-y-1/2 w-11 h-11 flex items-center justify-center bg-ink/60 backdrop-blur text-bone border border-line opacity-0 group-hover:opacity-100 transition-opacity hover:bg-crimson"
        >
          <CaretLeft size={16} />
        </button>
        <button
          onClick={() => embla && embla.scrollNext()}
          data-testid="gallery-next"
          className="absolute right-4 top-1/2 -translate-y-1/2 w-11 h-11 flex items-center justify-center bg-ink/60 backdrop-blur text-bone border border-line opacity-0 group-hover:opacity-100 transition-opacity hover:bg-crimson"
        >
          <CaretRight size={16} />
        </button>
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
          {images.map((_, i) => (
            <button
              key={i}
              onClick={() => scrollTo(i)}
              className={`h-1 transition-all duration-300 ${selected === i ? "w-8 bg-crimson" : "w-4 bg-bone/40"}`}
            />
          ))}
        </div>
      </div>
      <div className="flex gap-3 mt-3">
        {images.map((src, i) => (
          <button
            key={i}
            onClick={() => scrollTo(i)}
            data-testid={`gallery-thumb-${i}`}
            className={`w-16 h-20 overflow-hidden border transition-colors ${selected === i ? "border-crimson" : "border-line hover:border-bone"}`}
          >
            <img src={src} alt="" className="w-full h-full object-cover" />
          </button>
        ))}
      </div>
    </div>
  );
};

export default ProductGallery;
